import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'partidas',
})
export class PartidasPipe implements PipeTransform {

  transform(items: any[], filter: any[]): any {

    if (items) {

      if (filter['id_partida'] !== '') {

        items = items.filter(function (item) {

          return item.id == filter['id_partida'];

        });

      }

      return items;
    }

  }
}



// WEBPACK FOOTER //
// ./src/pipes/partidas/partidas.ts